import { render, staticRenderFns } from "./listOfCommodities.vue?vue&type=template&id=40a41838&scoped=true&"
import script from "./listOfCommodities.vue?vue&type=script&lang=js&"
export * from "./listOfCommodities.vue?vue&type=script&lang=js&"
import style0 from "./listOfCommodities.vue?vue&type=style&index=0&id=40a41838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a41838",
  null
  
)

export default component.exports